import Swiper from "swiper";

if ($('.js-sliderSpeakers').length > 0) {
  $(window).on('load', function() {
    let sliderSpeaker = new Swiper('.js-sliderSpeakers .swiper-container', {
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          slidesPerColumnFill: 'row',
          slidesPerColumn: 2,
          slidesPerGroup: 2,
          followFinger: false,
        },
      }
    });
  });
}
